export const tabsMixin = {
  methods: {
    // @vuese
    // Sprawdza czy link jest aktywny
    isActive(tab) {
      return (
        tab && tab.route && this.$route.name === tab.route.name && this.queryMatches(tab) && this.paramMatches(tab)
      );
    },

    // @vuese
    // Sprawdza, czy query parametry zakładki pasują do aktualnie otwratego widoku
    queryMatches(tab) {
      return this.matches(tab.route.query, 'query');
    },

    // @vuese
    // Sprawdza, czy parametry zakładki pasują do aktualnie otwratego widoku
    paramMatches(tab) {
      return this.matches(tab.route.params, 'params');
    },

    // @vuese
    // Sprawdza, czy parametry zakładki pasują do aktualnie otwratego widoku
    matches(property, routeKey) {
      if (!property) {
        return true;
      }

      return Object.keys(property).every(key => property[key] == this.$route[routeKey][key]);
    }
  }
};
